import { currentTripStateIdVar } from '../search';
import { currentSummaryPrice } from './recordPriceReactiveVars';
// Used to log pricing differences to datadog
export function recordSummaryPriceSideEffect(results, estabId, isCached = false) {
    var _a;
    if (isCached) {
        currentSummaryPrice({
            tripStateId: currentTripStateIdVar(),
            estabId,
            price: (_a = results.hotelAvailability) === null || _a === void 0 ? void 0 : _a.pricingSummary.price,
        });
    }
}
